import { parametric, pathSubscription, subscription } from 'nike-re-framejs';

export const loggedIn$ = pathSubscription(['loggedIn']);
export const accountShouldForceChangePassword$ = subscription(
    db => db.getIn(['account', 'userData', 'forceChangePassword']) && !db.getIn(['account', 'forcedPasswordChanged'])
);
export const accountUserData$ = pathSubscription(['account', 'userData']);
export const accountAvatar$ = pathSubscription(['account', 'userData', 'avatar']);
export const accountNickname$ = pathSubscription(['account', 'userData', 'nickname']);
export const accountPoints$ = pathSubscription(['account', 'userData', 'points']);
export const accountEmail$ = pathSubscription(['account', 'userData', 'email']);
export const accountPhone$ = pathSubscription(['account', 'userData', 'phone']);
export const accountCustomerId$ = pathSubscription(['account', 'userData', 'idZak']);
export const accountVerificationStatus$ = pathSubscription([
    'account',
    'userData',
    'verification',
    'verificationStatus'
]);

export const accountActionAllowed$ = parametric(action =>
    subscription(reason => !reason, accountForbiddenActionReason$(action))
);

export const accountForbiddenActionReason$ = parametric(action =>
    subscription(userData => {
        const reason = userData.getIn(['forbiddenActions', action]);
        return reason === null || reason === 0 || reason === '' || reason;
    }, accountUserData$)
);

export const accountBonuses$ = pathSubscription(['account', 'userData', 'bonuses']);
export const accountHasMarketingAgreement$ = pathSubscription(['account', 'userData', 'marketingAgreement']);
export const accountForcedActions$ = pathSubscription(['account', 'userData', 'forcedActions']);
export const accountForcedActionStatus$ = pathSubscription(['account', 'userData', 'forcedActionStatus']);
export const accountForcedActionsCrm$ = pathSubscription(['account', 'userData', 'forcedActionsCrm']);
export const accountForcedRequestedKyc$ = pathSubscription(['account', 'userData', 'forcedRequestedKyc']);
export const accountRegistrationStatus$ = pathSubscription(['account', 'userData', 'registrationStatus']);
export const accountUnconfirmedPolex$ = subscription(
    userData =>
        userData.getIn(['politickaAngazovanost'], false) && !userData.getIn(['politickaAngazovanostPotvrdena'], false),
    accountUserData$
);
